import {TABLET_BREAKPOINT} from '../../../common/scripts/constants';
import {Utils} from '../../../common/scripts/utils';

class ParallaxColumn {
    constructor() {
        this.wrapper = null;

        /**
         * Элементы которые двигаем
         * @type {array}
         */
        this.scrollItems = [];

        /**
         * Селектор элементов которые двигаем
         * @type {string}
         */
        this.itemsSelector = '.j-column-parallax-item:nth-child(4n + 1), .j-column-parallax-item:nth-child(4n + 3)';

        /**
         * Сдвиг элементов в паралаксе
         * @type {number}
         */
        this.shift = 0;

        /**
         * Стандартный сдвиг элементов в паралаксе, если не задан в атрибутах
         * @type {number}
         */
        this.defaultShift = 130;

        /**
         * Опции для настройки скрола
         * @type {object}
         */
        this.scrollOptions = {};

        /**
         * Отступ от края экрана - граница, которую должен пересечь элемент, чтобы начать прокручиваться
         * @type {number}
         */
        this.viewportOffset = TABLET_BREAKPOINT;
    }

    /**
     * Инициализация модуля
     * @param {object} options - параметры
     */
    init(options) {
        this.wrapper = options.wrapper;

        this._getElements();
        this._setDefaultSettings();
        this._initOptions();
        this._bindEvents();
    }

    /**
     * Получаем элементы со страницы
     * @private
     */
    _getElements() {
        this.scrollItems = Array.from(this.wrapper.querySelectorAll(this.itemsSelector));
    }

    /**
     * Устанавливаем начальный сдвиг
     * @private
     */
    _setDefaultSettings() {
        if (!this.scrollItems.length) {
            return;
        }

        this.shift = Number(this.wrapper.dataset.shift) || this.defaultShift;

        this.wrapper.style.paddingBottom = `${this.shift}px`;

        this.scrollItems.forEach((item) => {
            item.style.transform = `translateY(${this.shift}px)`;
        });
    }

    /**
     * Получаем опции для расчёта прокрутки
     * @private
     */
    _initOptions() {
        if (!this.scrollItems.length) {
            return;
        }

        /**
         * Высота раздела
         */
        this.scrollOptions.wrapperHeight = this.wrapper.clientHeight;

        /**
         * Отступ от начала страницы до блока с параллаксом
         */
        this.scrollOptions.indentTop = this.wrapper.getBoundingClientRect().top + Utils.getScrollTop();

        /**
         * Расстояние от начала страницы, до старта начала прокрутки
         */
        this.scrollOptions.startScrollPosition = this.scrollOptions.indentTop - this.viewportOffset;

        /**
         * Нижняя граница до куда прокручивается блок
         */
        this.scrollOptions.lowerBound = this.scrollOptions.indentTop + this.scrollOptions.wrapperHeight;
    }

    /**
     * Обрабатывает события
     * @private
     */
    _bindEvents() {
        if (!this.scrollItems.length) {
            return;
        }

        window.addEventListener('scroll', () => {
            this._onScroll();
        }, false);
    }

    /**
     * Выполняем события при скроле страницы
     * @private
     */
    _onScroll() {
        requestAnimationFrame(() => {
            this._changeParallax();
        });
    }

    /**
     * Изменяем сдвиг/паралакс
     * @private
     */
    _changeParallax() {
        const yPos = Utils.getScrollTop() - this.scrollOptions.startScrollPosition;
        const finish = this.scrollOptions.indentTop + yPos + this.shift;

        if (finish <= this.scrollOptions.lowerBound && yPos > 0) {
            // Считаем процент пролистывания блока, и отнимаем единицу, так как двигаем паралакс вниз
            const multiplier = Math.abs((yPos / this.scrollOptions.wrapperHeight) - 1) * this.shift;

            this.scrollItems.forEach((item) => {
                item.style.transform = `translateY(${multiplier}px)`;
            });
            this.wrapper.style.paddingBottom = `${multiplier}px`;
        } else if (yPos < 0) {
            this.scrollItems.forEach((item) => {
                item.style.transform = `translateY(${this.shift}px)`;
            });
            this.wrapper.style.paddingBottom = `${this.shift}px`;
        } else {
            this.scrollItems.forEach((item) => {
                item.style.transform = `translateY(0px)`;
            });
            this.wrapper.style.paddingBottom = `0px`;
        }
    }
}

export default ParallaxColumn;
